import React, { memo } from 'react';
import { Progress } from 'antd';

import './OnboardingProgress.less';

type OnboardingProgressProps = {
  completed: number;
  total: number;
};

export default memo(function OnboardingProgress({
  completed,
  total
}: OnboardingProgressProps) {
  return (
    <div className="onboarding-progress">
      <Progress
        percent={(100 / total) * completed}
        showInfo={false}
        strokeColor="#3553DB"
        trailColor="#F5F6FD"
      />
    </div>
  );
});
